import React from 'react'

const Header: React.FC = () => {
    return (
        <header className="text-center py-4 relative z-10">
            <div className="inline-block">
                <div className="flex items-center justify-center gap-4 mb-2">
                    <img
                        src="https://file.catke.com/familyTree/huang.png_/both/160x160/format/webp"
                        alt="黄氏印章"
                        className="w-16 h-16 opacity-80"
                    />
                    <h1 className="text-4xl md:text-5xl font-bold text-shadow-lg">
                        黄氏族谱
                    </h1>
                </div>
                <p className="text-base mt-3">
                    吾族本籍广东南雄珠玑巷，“居正”公为迁祖。
                    <br />
                    先祖南迁，卜居那白月桥村，子孙繁衍，世代相传。
                </p>
            </div>
        </header>
    )
}

export default Header
